import {Component} from '@angular/core';

@Component({
  selector: 'app-forgot-password-left-panel',
  templateUrl: './forgot-password-left-panel.component.html',
  styleUrls: ['./forgot-password-left-panel.component.css']
})
export class ForgotPasswordLeftPanelComponent {

}
